import React from 'react'
import { TooltipComponent } from '@syncfusion/ej2-react-popups'
import { toDashboardSentenceCase } from '@utils/dashboardText.util'
import './DashboardMetricItem.style.css'

type DashboardMetricItemProps = {
  leftLabel?: string
  leftIcon?: React.ReactNode
  rightLabel?: string
  value: React.ReactNode
  valueOver?: React.ReactNode
  infoTooltip?: string
  showInfoIcon?: boolean
  showWarningIcon?: boolean
  className?: string
  footer?: React.ReactNode
}

function DashboardMetricItem({
  leftLabel,
  leftIcon,
  rightLabel,
  value,
  valueOver,
  infoTooltip,
  showInfoIcon = false,
  showWarningIcon = false,
  className = '',
  footer,
}: DashboardMetricItemProps): React.ReactElement {
  const infoTooltipText =
    infoTooltip ?? (leftLabel ? `More info about ${leftLabel}` : 'More info')
  const displayLeftLabel = leftLabel
    ? toDashboardSentenceCase(leftLabel)
    : leftLabel

  return (
    <div className={`dashboard-metric-item ${className}`}>
      <div className="dashboard-metric-header">
        <span className="dashboard-metric-title-left">
          {leftIcon ?? displayLeftLabel}
          {showInfoIcon && (leftIcon ?? leftLabel) && (
            <TooltipComponent
              content={infoTooltipText}
              opensOn="Hover"
              cssClass="e-tooltip-template-css e-tooltip-tab-feature"
              position="TopCenter"
            >
              <span
                className="dashboard-metric-title-icon"
                role="img"
                aria-label={infoTooltipText}
              >
                <i className="mgc mgc_information_fill" aria-hidden />
              </span>
            </TooltipComponent>
          )}
        </span>
        {(rightLabel || showWarningIcon) && (
          <span className="dashboard-metric-title-right">
            {rightLabel}
            {showWarningIcon && (
              <i
                className="mgc mgc_warning_fill dashboard-metric-title-right-icon"
                aria-hidden
              />
            )}
          </span>
        )}
      </div>
      <div className="dashboard-metric-value">
        {value}
        {valueOver != null && (
          <>
            {' / '}
            <span className="dashboard-metric-value-over">{valueOver}</span>
          </>
        )}
      </div>
      {footer != null && (
        <div className="dashboard-metric-footer">{footer}</div>
      )}
    </div>
  )
}

export default DashboardMetricItem
